import { render, staticRenderFns } from "./AppSubHeader.vue?vue&type=template&id=38b26b88&"
import script from "./AppSubHeader.vue?vue&type=script&lang=ts&"
export * from "./AppSubHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports